import React from "react";

// Cards Components
import CardLineChart from "components/Cards/CardLineChart.js";
import CardBarChart from "components/Cards/CardBarChart.js";
import CardPageVisits from "components/Cards/CardPageVisits.js";
import CardSocialTraffic from "components/Cards/CardSocialTraffic.js";
import CardStats from "components/Cards/CardStats.js";
import CardTable from "components/Cards/CardTable.js";
import CardProfile from "components/Cards/CardProfile.js";
import CardSettings from "components/Cards/CardSettings.js";

// Dropdown Components
import UserDropdown from "components/Dropdowns/UserDropdown.js";
import NotificationDropdown from "components/Dropdowns/NotificationDropdown.js";
import TableDropdown from "components/Dropdowns/TableDropdown.js";
import PagesDropdown from "components/Dropdowns/PagesDropdown.js";

// Map Component
import MapExample from "components/Maps/MapExample.js";

export default function Examples() {
  return (
    <>
      <div className="relative bg-lightBlue-600 md:pt-32 pb-32 pt-12">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div>
            <h1 className="text-white text-3xl font-semibold mb-8 text-center">
              Template Components Examples
            </h1>
            <p className="text-lightBlue-200 text-center mb-8 max-w-4xl mx-auto">
              Esta página contiene ejemplos de todos los componentes disponibles en el template Notus React.
              Mantén esta página como referencia para futuras implementaciones.
            </p>
            
            {/* Stats Cards Section */}
            <div className="mb-8">
              <h2 className="text-white text-xl font-semibold mb-4">📊 Stats Cards</h2>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                  <CardStats
                    statSubtitle="TRAFFIC"
                    statTitle="350,897"
                    statArrow="up"
                    statPercent="3.48"
                    statPercentColor="text-emerald-500"
                    statDescripiton="Since last month"
                    statIconName="far fa-chart-bar"
                    statIconColor="bg-red-500"
                  />
                </div>
                <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                  <CardStats
                    statSubtitle="NEW USERS"
                    statTitle="2,356"
                    statArrow="down"
                    statPercent="3.48"
                    statPercentColor="text-red-500"
                    statDescripiton="Since last week"
                    statIconName="fas fa-users"
                    statIconColor="bg-orange-500"
                  />
                </div>
                <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                  <CardStats
                    statSubtitle="SALES"
                    statTitle="924"
                    statArrow="down"
                    statPercent="1.10"
                    statPercentColor="text-orange-500"
                    statDescripiton="Since yesterday"
                    statIconName="fas fa-percent"
                    statIconColor="bg-pink-500"
                  />
                </div>
                <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                  <CardStats
                    statSubtitle="PERFORMANCE"
                    statTitle="49,65%"
                    statArrow="up"
                    statPercent="12"
                    statPercentColor="text-emerald-500"
                    statDescripiton="Since last month"
                    statIconName="fas fa-chart-pie"
                    statIconColor="bg-lightBlue-500"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 md:px-10 mx-auto w-full -m-24">
        {/* Charts Section */}
        <div className="mb-8">
          <h2 className="text-blueGray-700 text-xl font-semibold mb-4">📈 Charts</h2>
          <div className="flex flex-wrap">
            <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
              <CardLineChart />
            </div>
            <div className="w-full xl:w-4/12 px-4">
              <CardBarChart />
            </div>
          </div>
        </div>

        {/* Data Tables Section */}
        <div className="mb-8">
          <h2 className="text-blueGray-700 text-xl font-semibold mb-4">📋 Data Tables</h2>
          <div className="flex flex-wrap">
            <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
              <CardPageVisits />
            </div>
            <div className="w-full xl:w-4/12 px-4">
              <CardSocialTraffic />
            </div>
          </div>
        </div>

        {/* Tables Section */}
        <div className="mb-8">
          <h2 className="text-blueGray-700 text-xl font-semibold mb-4">🗂️ Standard Tables</h2>
          <div className="flex flex-wrap">
            <div className="w-full mb-12 px-4">
              <CardTable />
            </div>
            <div className="w-full mb-12 px-4">
              <CardTable color="dark" />
            </div>
          </div>
        </div>

        {/* Forms and Profile Section */}
        <div className="mb-8">
          <h2 className="text-blueGray-700 text-xl font-semibold mb-4">📝 Forms and Profile</h2>
          <div className="flex flex-wrap">
            <div className="w-full lg:w-8/12 px-4 mb-8">
              <CardSettings />
            </div>
            <div className="w-full lg:w-4/12 px-4 mb-8">
              <CardProfile />
            </div>
          </div>
        </div>

        {/* Map Section */}
        <div className="mb-8">
          <h2 className="text-blueGray-700 text-xl font-semibold mb-4">🗺️ Map</h2>
          <div className="flex flex-wrap">
            <div className="w-full px-4">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
                  <div className="flex flex-wrap items-center">
                    <div className="relative w-full max-w-full flex-grow flex-1">
                      <h6 className="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
                        Map Example
                      </h6>
                      <h2 className="text-blueGray-700 text-xl font-semibold">
                        Google Maps Integration
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="p-4 flex-auto">
                  <div className="relative h-350-px">
                    <MapExample />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Dropdowns Section */}
        <div className="mb-8">
          <h2 className="text-blueGray-700 text-xl font-semibold mb-4">📂 Dropdowns</h2>
          <div className="flex flex-wrap">
            <div className="w-full px-4">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
                  <div className="flex flex-wrap items-center">
                    <div className="relative w-full max-w-full flex-grow flex-1">
                      <h6 className="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
                        Dropdown Components
                      </h6>
                      <h2 className="text-blueGray-700 text-xl font-semibold">
                        Available Dropdown Menus
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="p-4 flex-auto">
                  <div className="flex flex-wrap items-center space-x-4">
                    <div className="relative">
                      <label className="block text-blueGray-600 text-sm font-bold mb-2">
                        User Dropdown:
                      </label>
                      <UserDropdown />
                    </div>
                    <div className="relative">
                      <label className="block text-blueGray-600 text-sm font-bold mb-2">
                        Notifications:
                      </label>
                      <NotificationDropdown />
                    </div>
                    <div className="relative">
                      <label className="block text-blueGray-600 text-sm font-bold mb-2">
                        Table Actions:
                      </label>
                      <TableDropdown />
                    </div>
                    <div className="relative">
                      <label className="block text-blueGray-600 text-sm font-bold mb-2">
                        Pages Menu:
                      </label>
                      <PagesDropdown />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Components Documentation */}
        <div className="mb-8">
          <h2 className="text-blueGray-700 text-xl font-semibold mb-4">📚 Components Documentation</h2>
          <div className="flex flex-wrap">
            <div className="w-full px-4">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
                  <div className="flex flex-wrap items-center">
                    <div className="relative w-full max-w-full flex-grow flex-1">
                      <h6 className="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
                        Available Components
                      </h6>
                      <h2 className="text-blueGray-700 text-xl font-semibold">
                        Template Component Library
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="p-4 flex-auto">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    <div className="bg-blueGray-50 p-4 rounded">
                      <h3 className="font-semibold text-blueGray-700 mb-2">Cards</h3>
                      <ul className="text-sm text-blueGray-600 space-y-1">
                        <li>• CardStats - Tarjetas de estadísticas</li>
                        <li>• CardLineChart - Gráficos de líneas</li>
                        <li>• CardBarChart - Gráficos de barras</li>
                        <li>• CardPageVisits - Tabla de visitas</li>
                        <li>• CardSocialTraffic - Tráfico social</li>
                        <li>• CardTable - Tablas estándar</li>
                        <li>• CardProfile - Perfil de usuario</li>
                        <li>• CardSettings - Formularios de configuración</li>
                      </ul>
                    </div>
                    <div className="bg-blueGray-50 p-4 rounded">
                      <h3 className="font-semibold text-blueGray-700 mb-2">Dropdowns</h3>
                      <ul className="text-sm text-blueGray-600 space-y-1">
                        <li>• UserDropdown - Menú de usuario</li>
                        <li>• NotificationDropdown - Notificaciones</li>
                        <li>• TableDropdown - Acciones de tabla</li>
                        <li>• PagesDropdown - Menú de páginas</li>
                        <li>• IndexDropdown - Menú índice</li>
                      </ul>
                    </div>
                    <div className="bg-blueGray-50 p-4 rounded">
                      <h3 className="font-semibold text-blueGray-700 mb-2">Layout</h3>
                      <ul className="text-sm text-blueGray-600 space-y-1">
                        <li>• Sidebar - Navegación lateral</li>
                        <li>• AdminNavbar - Barra navegación admin</li>
                        <li>• AuthNavbar - Barra navegación auth</li>
                        <li>• IndexNavbar - Barra navegación landing</li>
                        <li>• HeaderStats - Cabecera con estadísticas</li>
                        <li>• Footer variations - Pie de página</li>
                        <li>• MapExample - Integración con mapas</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}